import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Conversation } from 'src/app/shared/models/messaging/conversation';
import { BonCommandeReference } from 'src/app/shared/models/bonCommandeReference';
import { ConstantsService } from '../constant/constants.service';
import { GenericCrudService } from '../generic-crud.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class BonCommandeReferenceService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllBonCommandeReference(): Observable<BonCommandeReference[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeReferenceUrl}/all`,
			'getAllBonCommandeReferences'
		);
	}

	getBonCommandeReferenceById(bonCommandeReferenceId: number): Observable<BonCommandeReference> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.bonCommandeReferenceUrl}/get/${bonCommandeReferenceId}`,
			'getBonCommandeReferenceById'
		);
	}

	updateBonCommandeReference(bonCommandeReference: BonCommandeReference): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.bonCommandeReferenceUrl}/update/${bonCommandeReference.id}`,
			`updateBonCommandeReference`,
			bonCommandeReference
		);
	}

	deleteBonCommandeReference(bonCommandeReferenceId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.bonCommandeReferenceUrl}/delete/${bonCommandeReferenceId}`,
			`deleteBonCommandeReference`
		);
	}

}
